import React from 'react'
import { Button, List, Paper } from '@mui/material'
import classNames from 'classnames'
import { IBillingCurrentStats } from '@app/@types/myEnergy'
import SetUpBillingPopup from '@app/containers/MyEnergy/Tabs/BillingPeriod/SetUpBillingPeriod'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import CurrentBillingPeriod from './BillingPeriodListItems/CurrentBillingPeriod'
import EnergyBillingPeriod from './BillingPeriodListItems/EnergyBillingPeriod'
import Statistics from './BillingPeriodListItems/Statistics'

interface Props {
  classes: Record<string, string>,
  admin: boolean,
  billingCurrentStats: IBillingCurrentStats,
  isMobile: boolean,
  isSetUpPeriodPopupOpen: boolean,
  isBillingPeriodsStatsPopupOpen: boolean,
  setUpBillingPeriodOpen: (...args: any[]) => void,
  billingPeriodsStatsOpen: (...args: any[]) => void,
  setUpBillingPeriodClose: (...args: any[]) => void,
  billingPeriodsStatsClose: (...args: any[]) => void,
}

class BillingPeriod extends React.Component<Props> {
  static displayName = 'BillingPeriod'

  componentWillUnmount() {
    const {
      setUpBillingPeriodClose,
      billingPeriodsStatsClose,
    } = this.props
    setUpBillingPeriodClose()
    billingPeriodsStatsClose()
  }

  render() {
    const {
      classes,
      billingCurrentStats,
      isMobile,
      admin,
      isSetUpPeriodPopupOpen,
      setUpBillingPeriodOpen,
      setUpBillingPeriodClose,
      isBillingPeriodsStatsPopupOpen,
      billingPeriodsStatsOpen,
    } = this.props
    return (
      <Paper className={classNames(
        classes.screenWrapper,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
        && classes.webView,
      )}
      >
        <Wrapper className={classes.buttonWrapper}>
          <Button
            className={classes.button}
            color="primary"
            onClick={setUpBillingPeriodOpen}
            disabled={!admin}
          >
            {I18n.t('buttons.set_up_billing_period')}
          </Button>
        </Wrapper>
        <List className={classes.list}>
          <CurrentBillingPeriod
            isMobile={isMobile}
            billingPeriod={billingCurrentStats.billing_period}
          />
          <EnergyBillingPeriod
            isMobile={isMobile}
            billingPeriod={billingCurrentStats.billing_period}
          />
          <Statistics
            isMobile={isMobile}
            isBillingPeriodsStatsPopupOpen={isBillingPeriodsStatsPopupOpen}
            billingPeriodsStatsOpen={billingPeriodsStatsOpen}
            total={billingCurrentStats.total}
          />
        </List>
        {isSetUpPeriodPopupOpen && (
          <SetUpBillingPopup
            isMobile={isMobile}
            isSetUpPeriodPopupOpen={isSetUpPeriodPopupOpen}
            setUpBillingPeriodOpen={setUpBillingPeriodOpen}
            setUpBillingPeriodClose={setUpBillingPeriodClose}
          />
        )}
      </Paper>
    )
  }
}

export default BillingPeriod
